export default [
  {
    icon: '📖',
    title: 'Bionic Markdown',
    path: 'https://www.npmjs.com/package/bionic-markdown',
    description:
      'A Node.js module which processes Markdown so that it is suitable for bionic reading.',
  },
  {
    icon: '📄',
    title: 'Frontmatter Processor',
    path: 'https://www.npmjs.com/package/markdown-frontmatter-processor',
    description:
      'A Node.js module which makes it easy to read and change YAML frontmatter in Markdown files.',
  },
  {
    icon: '🌐',
    title: 'Personal Website',
    path: 'https://github.com/ericjanto/personal-blog',
    description:
      'My personal website, created with Gatsby, react, and Node.js.',
  },
  {
    icon: '🎻',
    title: 'EUSO Website',
    path: '/euso-project',
    source:
      'https://github.com/Edinburgh-University-String-Orchestra/euso-website',
    description:
      'A minimalist Gatsby website for the Edinburgh University String Orchestra.',
  },
  {
    icon: '🎷',
    title: 'EUJO Website',
    path: 'https://eujo.eusa.ed.ac.uk/history/',
    description:
      'The official website for the Edinburgh University Jazz Orchestra.',
  },
]
